import {Box, Button, Stack, Typography, Skeleton} from '@mui/material';
import {useCallback, useState} from 'react';
import {useRqUsersPrimaryContactDetailByTask} from '../../../../react_query/tasks/UsersByTask';
import {useParams} from 'react-router-dom';
import {apiPost} from '../../../../axiosConfig';
import DialogApiRequestStatus from '../../../../components/dialogs/DialogApiRequestStatus';
import {broadCastCloseTab} from '../../../../react_query/tasks/ListTasks';

const UsersPrimaryContact = () => {
  const task = useParams();
  const taskId = Number(task.task_id);

  const {data, isLoading} = useRqUsersPrimaryContactDetailByTask(taskId);

  const [apiState, setApiState] = useState({
    status: '',
    error: null,
    successMsg: '',
  });

  const handleComplete = useCallback(() => {
    setApiState({status: 'pending', error: null, successMsg: ''});
    apiPost(`/v1/task/${taskId}`)
      .then(() => {
        setApiState({
          status: 'success',
          error: null,
          successMsg: 'Task been updated',
        });
        broadCastCloseTab();
      })
      .catch(error => {
        setApiState({
          status: 'error',
          error,
          successMsg: '',
        });
      });
  }, [taskId]);

  const handleCancel = useCallback(() => {
    broadCastCloseTab();
  }, []);

  const handleEdit = useCallback(() => {
    setApiState({status: '', error: null, successMsg: ''});
  }, []);

  const currentTask = data?.assignment?.split(' ').pop();

  // helper function for rendering a row
  const renderRow = (label: string, value?: string) => (
    <Stack direction='row' className='mb-2'>
      <Typography className='w-130 text-bold'>{label}</Typography>
      {isLoading ? (
        <Skeleton variant='text' width={150} />
      ) : (
        <Typography>: {value ?? '-'}</Typography>
      )}
    </Stack>
  );

  return (
    <Stack className='flex items-center justify-center'>
      <Box className='sponsor-info-sec'>
        <Typography variant='h5' className='text-white font-bold mb-5'>
          User Primary Contact {currentTask}
        </Typography>

        {renderRow('Partner Name', data?.partner_name)}
        {renderRow('Name', data?.primary_contact_name)}
        {renderRow('Email', data?.primary_contact_email)}
        {renderRow('Task Name', data?.task_name)}
        {renderRow('Requestable Type', data?.requestable_type)}
        {renderRow('Status', data?.status)}

        <Box className='flex justify-center items-center h-10vh'>
          <Button variant='outlined' onClick={handleComplete}>
            Complete
          </Button>
        </Box>

        {apiState.status !== '' && (
          <DialogApiRequestStatus
            apiState={apiState}
            onRetry={handleComplete}
            onEdit={handleEdit}
            onClose={handleCancel}
          />
        )}
      </Box>
    </Stack>
  );
};

export default UsersPrimaryContact;
